var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTractSignUpBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 720,
    viewBox: "0 0 320 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_2567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383 637H181C56.1836 637 -45 738.184 -45 863V863H383V637Z",
    fill: "#FF4F05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.523 210.487V424.968H179.63C179.559 427.195 179.523 429.43 179.523 431.674C179.523 545.099 270.53 637.048 382.793 637.048C495.056 637.048 586.063 545.099 586.063 431.674C586.063 429.43 586.027 427.195 585.957 424.968H586.063V200.315H585.823C580.632 91.5622 491.718 5 382.793 5C273.868 5 184.954 91.5622 179.763 200.315H179.523V210.26C179.523 210.298 179.523 210.336 179.523 210.374C179.523 210.412 179.523 210.449 179.523 210.487Z",
    fill: "#3036DC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134,
    cy: 562.5,
    rx: 75,
    ry: 74.5,
    fill: "#FFC004"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_2567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 720,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractSignUpBg);
export default __webpack_public_path__ + "static/media/tract_sign-up_bg.ab2918270bd81972cdcae1fcd1202003.svg";
export { ForwardRef as ReactComponent };